import { render, staticRenderFns } from "./MainResidenceTypeArray.vue?vue&type=template&id=ea7134b4&"
import script from "./MainResidenceTypeArray.vue?vue&type=script&lang=js&"
export * from "./MainResidenceTypeArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports